import { Injectable } from '@angular/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { finalize, from, Observable } from 'rxjs';
import { LoaderService } from '../loader/loader.service';

@Injectable({
	providedIn: 'root',
})
export class RecaptchaService {
	constructor(
		private readonly reCaptchaService: ReCaptchaV3Service,
		private readonly loaderService: LoaderService
	) {}

	executeAction(action: string): Observable<string> {
		this.loaderService.show();
		return from(this.reCaptchaService.execute(action)).pipe(
			finalize(() => this.loaderService.hide())
		);
	}
}
